import { render, staticRenderFns } from "./WorkflowComponents.vue?vue&type=template&id=2120cf62"
import script from "./WorkflowComponents.vue?vue&type=script&lang=js"
export * from "./WorkflowComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports